import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

/* eslint-disable */

/**
 * DEPRECATED: Auth token işlemleri artık Rest Client yerine interceptor'da yapılıyor.
 */
@Injectable({
	providedIn: 'root',
})
export class RestClientService {
	constructor(private http: HttpClient) {}

	public get(url: string, options?: any): Observable<any> {
		return this.http.get(url, options).pipe(catchError(this.handleError));
	}

	public post(url: string, body: string | FormData | Object, options?: any): Observable<any> {
		return this.http.post(url, body, options).pipe(catchError(this.handleError));
	}

	public patch(url: string, body: string, options?: any): Observable<any> {
		return this.http.patch(url, body, options).pipe(catchError(this.handleError));
	}

	public put(url: string, body: string | Object, options?: any): Observable<any> {
		return this.http.put(url, body, options).pipe(catchError(this.handleError));
	}

	public delete(url: string, options?: any): Observable<any> {
		return this.http.delete(url, options).pipe(catchError(this.handleError));
	}

	public fileUpload(url: string, body: any, options?: any): Observable<any> {
		return this.http.post(url, body, options).pipe(catchError(this.handleError));
	}

	protected handleError = (error: any) => {
		return throwError(() => error);
	};
}
